module.exports = __webpack_public_path__ + "static/media/plug-avatars.7dc1386d.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/plug-avatars.jpg
// module id = 123
// module chunks = 1